module.exports = __webpack_public_path__ + "static/before-3-dcf78acadc39dc7474a9b67203a451c6.png";